module.exports = __webpack_public_path__ + "static/media/creativeschool_main_t.f0ba0eed.jpg";